import React, {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
  } from "react";
  import { Socket, io } from "socket.io-client";
  
  
  export interface ISocket {
   
  }
  
  interface ISocketFormatadoContextData {
    socket:Socket;
    handleSetSocket(so:Socket):void;
  }
  
  interface ISocketFormatadoProviderProps {
    children: ReactNode;
  }
  
  const SocketContext = createContext({} as ISocketFormatadoContextData);
  
  function SocketProvider({ children }: ISocketFormatadoProviderProps) {
    const [socket,setSocket] = useState({} as Socket);

    function handleSetSocket(so:Socket){
      setSocket(so)
    }

    return (
      <SocketContext.Provider
        value={{
          handleSetSocket,
          socket
        }}
      >
        <>{children}</>
      </SocketContext.Provider>
    );
  }
  
  function useSocket() {
    const context = useContext(SocketContext);
  
    return context;
  }
  
  export { SocketProvider, useSocket };
  